import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { useAppEx, useDetailStore } from '@vt/hooks'
import { pick, concat } from 'lodash-es'
import { Select, Loader } from '@mantine/core'

const StyledIndicatorScore = styled.div`
  padding: 24px;
  border-bottom: 1px solid #e7e7e7;
  .indicator-title {
    font-weight: 500;
    font-size: 14px;
    color: #000000e6;
    margin-bottom: 15px;
    span {
      font-weight: 500;
      font-size: 14px;
      color: #e34d59;
      margin-right: 4px;
    }
  }
  .indicator-content {
    gap: 16px 80px;
    .indicator-item {
      gap: 24px;
      .item-title {
        font-size: 14px;
        color: #000000e6;
        line-height: 22px;
      }
    }
  }
`

const Content = function ({ setStandardScore }) {
  const [scoreState, setScoreState] = useState([])
  const [loading, setLoading] = useState(false)
  const { originalData, currentData } = useDetailStore((state) =>
    pick(state, ['originalData', 'currentData'])
  )
  const { getDitto } = useAppEx((state) => pick(state, ['getDitto']))

  const getData = async () => {
    setLoading(true)
    let data = []
    const res = await getDitto('standard').fetchTbDataRaw({
      filters: {
        queries: [
          {
            slug: 'parentIds',
            value: currentData.standard[0][0].objectId,
            queryType: ['equal'],
          },
          {
            slug: 'isParentNode',
            value: true,
            queryType: ['notEqual'],
          },
          {
            slug: 'level',
            value: 3,
            queryType: ['equal'],
          },
          {
            slug: 'isItQualifiedToFillInTheForm',
            value: true,
            queryType: ['notEqual'],
          },
        ],
        logicType: 'and',
      },
      pageSize: 10000,
    })
    data = res.tbData || []
    const echoData = await getDitto(
      null,
      'zhibiaoshifouhege_0468868f_1e1b_4055_a93b_9615dccb963d'
    ).fetchTbDataRaw({
      filters: {
        queries: [
          {
            slug: 'objectIdInfo',
            value: currentData.objectId,
            queryType: ['equal'],
          },
          {
            slug: 'standard',
            value: currentData.standard[0][0].objectId,
            queryType: ['contain'],
          },
        ],
        logicType: 'and',
      },
      pageSize: 10000,
    })
    if (echoData.tbData.length) {
      data = data.map((item) => {
        const echoItem = echoData.tbData.find(
          (f) => f.standard[0][2] === item.objectId
        )
        const {
          area,
          isQualified,
          objectIdInfo,
          orTableDataId,
          nameOfConstructionSite,
          standard,
        } = echoItem
        return {
          title: item.title,
          parentIds: item.parentIds,
          objectId: item.objectId,
          isQualified,
          map: {
            area,
            objectIdInfo,
            orTableDataId,
            nameOfConstructionSite,
            isQualified,
            standard,
          },
          primary: {
            objectIdInfo,
            standard,
          },
        }
      })
    } else {
      const { area, objectId, tableDataId, nameOfConstructionSite } =
        originalData
      data = data.map((item) => {
        const parentIds = concat(item.parentIds, item.objectId)
        return {
          ...item,
          isQualified: ['暂不涉及'],
          map: {
            area,
            objectIdInfo: objectId,
            orTableDataId: tableDataId,
            nameOfConstructionSite,
            isQualified: ['暂不涉及'],
            standard: [parentIds],
          },
        }
      })
    }
    setScoreState(data)
    setStandardScore(
      data,
      data.filter((f) => f.isQualified).length === data.length
    )
    setLoading(false)
  }

  useEffect(() => {
    getData()
  }, [currentData])

  const scroreChange = (val, item) => {
    const arr = scoreState
    console.log(scoreState, 'scoreStatescoreState')
    // 将操作过的末级指标id抽出来，用来判断是否操作过该指标
    const operatedStandard = scoreState.map((m) => m.objectId)
    // 操作过的末级指标index
    const operatedIndex = operatedStandard.findIndex((f) => item.objectId === f)
    const { area, objectId, tableDataId, nameOfConstructionSite } = originalData
    const parentIds = concat(item.parentIds, item.objectId)
    arr[operatedIndex] = {
      ...arr[operatedIndex],
      isQualified: [val],
      map: {
        area,
        objectIdInfo: objectId,
        orTableDataId: tableDataId,
        nameOfConstructionSite,
        isQualified: [val],
        standard: [parentIds],
      },
      primary: {
        objectIdInfo: objectId,
        standard: [parentIds],
      },
    }
    setScoreState([...arr])
    setStandardScore(
      arr,
      arr.filter((f) => f.isQualified).length === arr.length
    )
  }

  return (
    <StyledIndicatorScore>
      {loading && (
        <div>
          <Loader className="m-auto" size={30} />
        </div>
      )}
      {!loading && (
        <>
          <p className="indicator-title">
            <span>*</span>指标是否合格
          </p>
          <div className="indicator-content grid grid-cols-2 justify-between">
            {scoreState
              .filter((f) => !f.isItQualifiedToFillInTheForm)
              .map((item) => {
                return (
                  <div className="indicator-item flex items-center justify-between">
                    <p className="item-title">{item.title}</p>
                    <Select
                      styles={{ input: { width: '90px' } }}
                      data={[
                        { value: '是', label: '合格' },
                        { value: '否', label: '不合格' },
                        { value: '暂不涉及', label: '暂不涉及' },
                      ]}
                      value={item.isQualified && item.isQualified[0]}
                      onChange={(val) => {
                        scroreChange(val, item)
                      }}
                    />
                  </div>
                )
              })}
          </div>
        </>
      )}
    </StyledIndicatorScore>
  )
}
export default Content
